import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoginAwareComponent } from '../login-aware-component';
import { GraphClientService } from '../services/graph-client-service';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

/**
 * The component displays a welcome message to anonymous users. Once users authenticate,
 * the component is not shown. Users see the GreeterComponent instead. The message is
 * sourced from a SharePoint Online list.
 */
@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent extends LoginAwareComponent implements OnInit, OnDestroy {
  private title: string;
  private blurb: string;

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    broadcastService: BroadcastService,
    authService: MsalService,
    private graphClient: GraphClientService) {
    super(diagnosticsFactory.create('WelcomeComponent'), broadcastService, authService);
  }

  ngOnInit() {
    super.ngOnInit();

    if (!this.loggedIn) {
      this.setValues();
    }
  }

  private setValues() {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
        const dynamicData = data as any;

        if (dynamicData && dynamicData.value && dynamicData.value.length === 1) {
          this.title = dynamicData.value[0].fields['Title'];
          this.blurb = dynamicData.value[0].fields['Text'];
        } else {
          this.diagnostics.logError(
            `Error parsing results from call to Resources list. ` +
            `List data: ${ JSON.stringify(data)}`);
        }
      }, error => {
        this.diagnostics.logError(`Error accessing Resources list: ${ JSON.stringify(error) }.`);
    });
  }
}
